/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '@global/colors';
import { formControlContainer } from '@assets/styles/formStyles';
import SociollaText from '@components/sociolla/SociollaText';
import FormLabel from '@components/form/common/FormLabel';
import FormError from '@components/form/common/FormError';
import PropTypes from 'prop-types';

const propTypes = {
  testID: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
  ]),
  trackBy: PropTypes.string,
  labelKey: PropTypes.string,
  options: PropTypes.array,
  containerStyle: PropTypes.object,
  itemStyle: PropTypes.object,
  minWidth: PropTypes.number,
};

const defaultProps = {
  testID: 'status-picker',
  value: '',
  trackBy: '',
  labelKey: '',
  options: [],
  containerStyle: {},
  itemStyle: {},
  minWidth: 0,
};

const checkValue = (value, key) => {
  return typeof value == 'object' && key ? value[key] : value;
};

const StatusPicker = (props) => {
  const {
    testID = 'status-picker',
    value = '',
    trackBy = '',
    labelKey = '',
    options = [],
    containerStyle = {},
    itemStyle = {},
    minWidth = 0,
  } = props;

  return (
    <View testID={testID} style={[formControlContainer, containerStyle]}>
      <FormLabel {...props} />
      <View testID={`${testID}-options`} style={styles.statusContainer}>
        {options.map((item, idx) => {
          // No selection (empty/null/undefined) must highlight nothing. Guard before
          // the loose == compare, else value '' matches a false option ('' == false).
          const hasValue =
            value !== '' && value !== null && value !== undefined;
          const itemActive =
            hasValue &&
            (checkValue(value, trackBy) == checkValue(item, trackBy) ||
              checkValue(value, trackBy) == checkValue(item, labelKey));
          return (
            <TouchableOpacity
              testID={`${testID}-option-${idx}`}
              key={idx}
              activeOpacity={0.6}
              style={[
                styles.statusItem,
                itemActive ? { backgroundColor: Colors.blue6 } : {},
                itemStyle,
                minWidth ? { minWidth: minWidth } : {},
              ]}
              onPress={() => props.onChange(item)}>
              <SociollaText style={{ fontSize: 13 }}>
                {checkValue(item, labelKey)}
              </SociollaText>
            </TouchableOpacity>
          );
        })}
      </View>
      <FormError {...props} />
    </View>
  );
};

const styles = StyleSheet.create({
  statusContainer: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  statusItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 15,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: Colors.grey0,
    marginRight: 10,
    marginBottom: 10,
  },
});

StatusPicker.propTypes = propTypes;
StatusPicker.defaultProps = defaultProps;

export default React.memo(StatusPicker, (prev, next) => prev == next);
